<template>
  <v-layout>
    <v-container>
      <v-row>
        <v-col cols="6" sm="6" md="6" justify-center>
          <h1>Forgot Password</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" sm="6" md="6" justify-center>
          <p>
            Enter your email address below. If we have it on file we will send
            you a reset email.
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" sm="6" md="6" justify-center>
          <v-form ref="form" autocomplete="off">
            <v-text-field
              ref="email"
              v-model="email"
              :rules="requiredField"
              label="Email"
              required
            ></v-text-field>

            <v-btn block color="primary" @click="submit">Send Email</v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <div class="text-center">
      <v-snackbar
        v-model="snackbar.show"
        :timeout="timeout"
        :color="snackbar.color"
        :top="y === 'top'"
      >
        {{ snackbar.message }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </div>
  </v-layout>
</template>

<script>
/* eslint-disable no-debugger */
export default {
  data: () => ({
    snackbar: {
      show: false,
      message: null,
      color: null,
    },
    timeout: 4000,
    y: "top",
    email: "",
    requiredField: [
      (v) => !!v || "This field is required",
      (v) => v.length >= 3 || "Minimum length is 3 characters",
    ],
  }),
  created() {},
  methods: {
    keyupSubmit(e) {
      if (e.keyCode === 13) {
        this.submit();
      }
    },
    submit() {
      //OID10001
      if (this.$refs.form.validate()) {
        const baseURI = this.$store.getters.getBaseUrl + "forgotPassword";
        this.$http
          .post(baseURI, {
            email: this.email,
          })
          .then(() => {
            this.snackbar = {
              message: "If Email found, a reset link will be sent.",
              color: "success",
              show: true,
            };
            this.resetFields();
          })
          .catch(() => {
            this.snackbar = {
              message: "If Email found, a reset link will be sent.",
              color: "success",
              show: true,
            };
            this.resetFields();
          });
      }
    },
    resetFields() {
      this.$refs.form.reset();
    },
  },
  mounted() {
    this.$store.commit("setMenuOptions", []);
  },
};
</script>
<style>
</style>
